
const eventDates = {
  init() {
    const futureEventDateElements = document.querySelectorAll('[id^="future-event-date-"]');
    const pastEventDateElements = document.querySelectorAll('[id^="past-event-date-"]');

    if (futureEventDateElements.length <= 0 && pastEventDateElements.length <= 0) {
      return;
    }

    const eventDateElements = [...futureEventDateElements, ...pastEventDateElements]
      .filter(el => el.dataset.formatted !== 'true');

    eventDateElements.forEach(eventDateElement => {
      eventDateElement.dataset.formatted = 'true';
      const eventDate = eventDateElement.textContent;
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const data = {
        [csrfTokenName]: csrfTokenValue,
        timezone: userTimezone,
        eventDate: eventDate // Pass the event date
      };

      fetch('/actions/video-consortium-module/date-time/timezone', {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json, text-plain",
          'X-Requested-With': 'XMLHttpRequest',
          "CRAFT_CSRF_TOKEN": csrfTokenValue,
        },
        method: 'POST',
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(data => {
        // Parse ids of the shape `${type}-event-date-${suffix}` where suffix
        // may contain additional dashes (e.g. `future-event-date-spotlight-12-3`).
        const match = eventDateElement.id.match(/^(future|past)-event-date-(.+)$/);
        if (!match) return;
        const [, type, suffix] = match;
        const formattedDateElement = document.getElementById(`formatted-${type}-date-${suffix}`);

        // Directly use the formatted date returned from the server
        if (formattedDateElement && data && data.formattedDate) {
          formattedDateElement.textContent = data.formattedDate;
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  }
};

export default eventDates;